/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccessDeniedExceptionResponse,
  ApiRequestValidationExceptionResponse,
  BadRequestExceptionResponse,
  CategoryListResponse,
  InternalServerErrorExceptionResponse,
  TopicListResponse,
} from '../models/index';
import {
    AccessDeniedExceptionResponseFromJSON,
    AccessDeniedExceptionResponseToJSON,
    ApiRequestValidationExceptionResponseFromJSON,
    ApiRequestValidationExceptionResponseToJSON,
    BadRequestExceptionResponseFromJSON,
    BadRequestExceptionResponseToJSON,
    CategoryListResponseFromJSON,
    CategoryListResponseToJSON,
    InternalServerErrorExceptionResponseFromJSON,
    InternalServerErrorExceptionResponseToJSON,
    TopicListResponseFromJSON,
    TopicListResponseToJSON,
} from '../models/index';

export interface GetCategoriesRequest {
    projectModeGroup?: GetCategoriesProjectModeGroupEnum;
    limit?: number;
    offset?: number;
}

export interface GetTopicsRequest {
    limit?: number;
    offset?: number;
}

/**
 * 
 */
export class TaxonomyApi extends runtime.BaseAPI {

    /**
     */
    async getCategoriesRaw(requestParameters: GetCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoryListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['projectModeGroup'] != null) {
            queryParameters['projectModeGroup'] = requestParameters['projectModeGroup'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/taxonomy/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CategoryListResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCategories(requestParameters: GetCategoriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoryListResponse> {
        const response = await this.getCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTopicsRaw(requestParameters: GetTopicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopicListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/taxonomy/topics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopicListResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTopics(requestParameters: GetTopicsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopicListResponse> {
        const response = await this.getTopicsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetCategoriesProjectModeGroupEnum = {
    Dobro: 'dobro',
    Plus: 'plus'
} as const;
export type GetCategoriesProjectModeGroupEnum = typeof GetCategoriesProjectModeGroupEnum[keyof typeof GetCategoriesProjectModeGroupEnum];
